/**
 * Resource danh mục Tiết tiểu mục
 * ntduong2 24/4/2023
 */
export default {
  Title: 'Tiết',
  Dictionary: 'Danh mục',
  FolderPath: '/ Mục lục ngân sách / Tiết',
  BudgetItemDetailCode: 'Mã tiết *',
  BudgetItemDetailName: 'Tên tiết *',
  Description: 'Diễn giải',
};
